import { env, buildEndpointUrl } from '@/lib/env'

const base = () => env.kuroboard.dataBaseUrl

export const kuroboardApi = {
  overview: () => buildEndpointUrl(base(), 'overview.json'),
  projects: () => buildEndpointUrl(base(), 'projects.json'),
  project: (id: string) => buildEndpointUrl(base(), `projects/${id}.json`),
  notifications: () => buildEndpointUrl(base(), 'notifications.json'),
}
